import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';

import { Node } from 'src/app/models/node.model';
import * as fromStore from 'src/app/store/';

@Component({
  selector: 'app-widget-monitoring',
  templateUrl: './widget-monitoring.component.html',
  styleUrls: ['../widgets.scss', './widget-monitoring.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WidgetMonitoringComponent implements OnInit {
  private store = inject(Store<fromStore.State>);

  downNodes$: Observable<Node[]> = this.store.select(fromStore.getAllDownNodes);

  isLoading$: Observable<boolean> = this.store.select(
    fromStore.getDownNodesLoading,
  );

  isLoaded$: Observable<boolean> = this.store.select(
    fromStore.getDownNodesLoaded,
  );

  orionURL$: Observable<string> = this.store.select(fromStore.getOrionURL);

  errorMessage$: Observable<string> = this.store.select(
    fromStore.getDownNodesError,
  );

  ngOnInit(): void {
    this.store
      .select(fromStore.getDownNodesLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadDownNodes());
        }
      });
  }
}
